import { Auth } from '@chocolate-soup-inc/cs-api-consumer-utils';

const redirectSignIn = `${window.location.origin}${import.meta.env.REACT_APP_CALLBACK_PATH}`;
const redirectSignOut = `${window.location.origin}${import.meta.env.REACT_APP_LOGOUT_PATH}`;

export const authOptions = {
  region: import.meta.env.REACT_APP_REGION,
  userPoolId: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  identityPoolId: import.meta.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  authenticationFlowType: 'code',
  clientMetadata: {
    app: 'internal-portal'
  },

  // (optional) - Hosted UI configuration
  oauth: {
    domain: import.meta.env.REACT_APP_AUTH_DOMAIN,
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    // clientId: `${import.meta.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID}:f3vk6nvcun052qukgnums3bjllmgrq43ea96mj0fb7g82dfro42`,
    redirectSignIn,
    redirectSignOut,
    responseType: 'code'
  }
};

if (import.meta.env.REACT_APP_STAGE != 'production')
  console.debug({
    message: 'Cognito Auth Options',
    authOptions
  });

Auth.configure(authOptions);
